import protoRoot from "../proto-root";

const name = "stopMonitoringRPCRequest";

function create() {
  const StopMonitoringRPCRequest = protoRoot.lookupType(
    "comm.StopMonitoringRPCRequest"
  );

  return { payload: StopMonitoringRPCRequest.create(), name };
}

const stopMonitoringRPCRequest = {
  create,
  name,
};

export default stopMonitoringRPCRequest;
